import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { EEnvironnement } from "../models/EEnvironnement";

@Injectable({
    providedIn: 'root'
})
export class GlobalAppService {

constructor() { }

    getEnvironnement() : number {

        let env = EEnvironnement.PROD;
        if(environment.apiUrl == "https://coachcompanion.fr/") {
            env = EEnvironnement.PROD
        }else {
            env = EEnvironnement.PROD
        }

        return env;
    }
}